import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { MaskedLines, Reveal } from "@/components/site/Reveal";
import EventCard from "@/components/site/EventCard";

export default function Events() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  const next = events[0];

  return (
    <div className="pt-32 md:pt-44">
      <section className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-brand-orange mb-6">/ Upcoming Events</div>
        <h1 className="font-head font-extrabold uppercase leading-[0.82] tracking-tighter text-[16vw] md:text-[12vw]">
          <MaskedLines lines={["The", <>Line<span className="text-brand-orange">up</span></>]} />
        </h1>
        <Reveal delay={0.4} className="mt-6 max-w-md text-brand-ink/60 text-lg">
          Every date on the calendar, in one place. Tap any event to grab your ticket.
        </Reveal>
      </section>

      {/* Featured next event */}
      {next && (
        <section className="max-w-[1400px] mx-auto px-5 md:px-10 mt-20">
          <Reveal>
            <div className="relative grid md:grid-cols-2 border border-brand-ink/10 overflow-hidden">
              <div className="relative aspect-[4/3] md:aspect-auto min-h-[320px] overflow-hidden">
                <img src={next.cover_image_url} alt={next.title} className="absolute inset-0 w-full h-full object-cover" />
              </div>
              <div className="p-8 md:p-14 flex flex-col justify-center">
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand-orange">Next up · {next.city}</span>
                <h2 className="font-head font-extrabold text-5xl md:text-7xl uppercase leading-none mt-3">{next.title}</h2>
                <p className="text-brand-ink/60 mt-4 max-w-md">{next.description}</p>
                <div className="flex flex-wrap gap-x-8 gap-y-2 mt-6 font-mono text-xs uppercase tracking-wider text-brand-ink/70">
                  <span>{next.date}</span><span>{next.time}</span><span>{next.venue}</span>
                  <span className="text-brand-orange">{next.is_free ? "Free · RSVP" : `$${next.price}`}</span>
                </div>
                {next.lineup?.length > 0 && (
                  <div className="mt-6 flex flex-wrap gap-2">
                    {next.lineup.map((a) => (
                      <span key={a} className="border border-brand-ink/15 px-3 py-1.5 text-xs font-mono uppercase tracking-wide">{a}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </Reveal>
        </section>
      )}

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 mt-16 pb-28 md:pb-40">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {events.map((e, i) => (
            <EventCard key={e.id} event={e} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
